import { Footer } from '@monorepo-hol/design-system';
import { useLanguageContext } from '../provider/LanguageProvider';
import { usePdfContext } from '../provider/PdfProvider';

export function FooterNavPdf() {
  const { LangState } = useLanguageContext();

  const { isPdfViewerDocumentLoaded, catalogData } = usePdfContext();

  if (isPdfViewerDocumentLoaded && catalogData.catalogType !== 'smartDoc')
    return null;

  return <Footer lang={LangState.language} />;
}
